import * as React from 'react'

import { NextPage, withScridId } from '@grandvisionhq/next'
import { Hooks, Types } from '@grandvisionhq/stores-v2'
import { compose } from '@grandvisionhq/utils'
import { Page, Props } from '@grandvisionhq/www-next/pages/stores'

import { withCms, withLayout } from '../cms'

const StoresPage: NextPage<Props | undefined> = (props) => {
  const { useDefaultStoreSearchFilters } = Hooks
  const { openNow, openOnTheWeekend, wheelChairAccessible } = useDefaultStoreSearchFilters()
  const storeSearchFilters: Types.StoreSearchFilterMap | undefined = React.useMemo(() => {
    return !openNow || !openOnTheWeekend || !wheelChairAccessible
      ? undefined
      : { openNow, openOnTheWeekend, wheelChairAccessible }
  }, [openNow, openOnTheWeekend, wheelChairAccessible])

  return <Page {...props} storeSearchFilters={storeSearchFilters} />
}

StoresPage.getInitialProps = Page.getInitialProps

export default compose<Props, Props>(withCms(), withLayout(), withScridId())(StoresPage)
